import { render, staticRenderFns } from "./ProductReviewCard.vue?vue&type=template&id=38889c96&scoped=true&"
import script from "./ProductReviewCard.vue?vue&type=script&lang=ts&"
export * from "./ProductReviewCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductReviewCard.vue?vue&type=style&index=0&id=38889c96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38889c96",
  null
  
)

export default component.exports